import spotlightConfig from '@core/config/spotlight.json';

const emptyRules = {
  input: [],
  geo: [],
  fallback: [],
};

type Params = {
  degree: string;
  category: string;
  subject: string;
  spotlightConfigOverride?: Record<string, any>;
};

const getSpotlightRulesForDcs = ({ degree, category, subject, spotlightConfigOverride = undefined }: Params) => {
  const dcsKey = `${degree}|${category}|${subject}`;
  const config = spotlightConfigOverride ?? spotlightConfig;
  const rules = config[dcsKey];
  return rules ?? emptyRules;
};

export default getSpotlightRulesForDcs;
